import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field } from "redux-form";
import { FormGroup, Label, Collapse, Modal, ModalBody } from "reactstrap";


import Aux from "../../../system/containers/Aux";
import TextInput from "../../../system/fields/TextInput";
import * as validations from "../../../system/utils/Validation";
import Wysiwyg from "../../../system/fields/Wysiwyg";

class DestinationLegs extends Component {
  constructor(props, leg, index, fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.toggleHotel = this.toggleHotel.bind(this);
    this.toggleCity = this.toggleCity.bind(this);
    this.state = {
      collapse: true,
      hotelToggle: false,
      cityToggle: false,
    };
  }
  
  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }
  
  toggleCity() {
    this.setState({
      cityToggle: !this.state.cityToggle,
    })
  }
  
  toggleHotel() {
    this.setState({
      hotelToggle: !this.state.hotelToggle,
    })
  }
  
  render() {
    const { props } = this;
    const { leg } = props;
    return (
      <Aux>
        {!this.state.collapse && (
          <div className="toggle" onClick={this.toggle}>
            <i className="fas fa-eye" /> <span>Expand</span>
          </div>
        )}
        {this.state.collapse && (
          <div className="toggle" onClick={this.toggle}>
            <i className="fas fa-eye-slash" /> <span>Collapse</span>
          </div>
        )}
        
        <Collapse isOpen={this.state.collapse}>
          <div className={"row"}>
            <div className={"col-8"}>
              <Label>Title</Label>
              <Field
                name={`${leg}.title`}
                component={TextInput}
                validate={validations.required}
              />
            </div>
            <div className={"col-4"}>
              <Label>Day From - To</Label>
              <Field
                name={`${leg}.day_from_to`}
                component={TextInput}
                validate={validations.required}
              />
            </div>
          </div>
          <div className={"row"}>
            <div className={"col-12"}>
              <Label>Description</Label>
              <Field
                name={`${leg}.description`}
                component={Wysiwyg}
                validate={validations.required}
              />
            </div>
          </div>
        </Collapse>
        
        
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    hotels: state.overview.hotels,
    cities: state.overview.cities,
  }
};

export default connect(mapStateToProps)(DestinationLegs);



// WEBPACK FOOTER //
// ./src/containers/Deals/components/Guide.jsx